"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var section = (0, _glamor.css)(_css.clearfix, {
  paddingTop: (0, _css.unitRem)(2),

  "&:first-child": {
    paddingTop: 0
  }
});

var title = (0, _glamor.css)({
  fontSize: (0, _css.unitRem)(1),
  fontWeight: 700,

  color: _css.colors.white,
  marginBottom: (0, _css.unitRem)(1)
});

var notes = (0, _glamor.css)({
  marginBottom: (0, _css.unitRem)(1)
});

var note = (0, _glamor.css)({
  fontWeight: 400,
  color: _css.colors.gray,

  marginTop: (0, _css.unitRem)(-0.5),
  marginBottom: (0, _css.unitRem)(1.5)
});

var noteValue = (0, _glamor.css)({
  color: _css.colors.white
});

var hr = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(2)
});

var credit = (0, _glamor.css)({
  display: "flex",
  justifyContent: "space-between"
});

var PaymentFormSection = function PaymentFormSection(props) {
  return _react2.default.createElement(
    "section",
    { className: section },
    props.title && _react2.default.createElement(
      "div",
      { className: credit },
      _react2.default.createElement(
        "h1",
        { className: title },
        props.title
      ),
      props.credit && _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "span",
          {
            className: (0, _glamor.css)({ color: _css.colors.gray, verticalAlign: "middle" })
          },
          "Payments by",
          _react2.default.createElement(_components.TextButtonLibrary, {
            mode: "small-gray-underlined",
            href: props.braintreeLink,
            label: "Braintree",
            newWindow: true
          })
        )
      )
    ),
    props.nextCharge && _react2.default.createElement(
      "h2",
      { className: note },
      props.nextCharge
    ),
    _react2.default.createElement(
      "div",
      null,
      props.children,
      !props.hideRule && _react2.default.createElement(_Hr2.default, { className: hr }),
      props.existingMethod || props.nextCharge ? _react2.default.createElement(
        "div",
        { className: notes },
        props.existingMethod && _react2.default.createElement(
          "h2",
          { className: note },
          "Current Settings:",
          " ",
          _react2.default.createElement(
            "span",
            { className: noteValue },
            props.existingMethod
          )
        )
      ) : null
    )
  );
};

exports.default = PaymentFormSection;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentForm/component/PaymentFormSection.jsx
// module id = 2782
// module chunks = 0